import { joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, request, services } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

export default {
  name: 'FileItemCard',

  props: {
    value: {
      type: [ String, Object ],
      default: () => {
        return {}
      }
    },

    currentChosenFileId: String,
    readonly: Boolean,
    compact: Boolean,

    rounded: {
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: true
    },

    displayMenu: {
      type: Boolean,
      default: true
    },

    flat: {
      type: Boolean,
      default: false
    },

    include: {
      type: Array,
      default: () => {
        return [ 'edit', 'update', 'download', 'export', 'remove' ]
      }
    },

    maxWidth: [ Number, String ],
    minWidth: [ Number, String ],
    width: [ Number, String ],

    small: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      file: undefined
    }
  },

  watch: {
    value: {
      handler() {
        this.getFileMeta()
      },
      deep: true
    }
  },

  mounted() {
    this.getFileMeta()
  },

  methods: {
    cachedGet: Cache.wrapWithCache(async (key, id) => {
      return await request.get(joinURLPath(services.storage, id), undefined, { return: 'meta' })
    }),

    async getFileMeta() {
      if (typeof this.value === 'string') {
        try {
          const [ id1, id2 ] = this.value.split('/')
          const fileId = id2 || id1
          if (fileId) {
            const data = await this.cachedGet(`${services.storage}:${fileId}`, fileId)
            if (data) {
              this.file = data
            }
          }
        } catch (error) {
          this.$emit('error')
          globalErrorHandler(error)
        }
      } else {
        this.file = this.value
      }
    }
  },

  render
}
